import Step1 from "../assets/1.webp";
import Step2 from "../assets/2.webp"
import Step3 from "../assets/3.webp";
import { FaDoorOpen, FaFingerprint, FaTelegramPlane } from "react-icons/fa";

export default function Howitworks(){
    return(
        <div className="mt-[140px] text-[#1A202C] lg:px-[15%]  bg-[#f8fafc]">
        <div className="max-w-6xl mx-auto px-4 py-16 relative">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">How does it work?</h2>
          <p className="text-center text-gray-600 mb-8 text-lg">Get started in 10 minutes with 3 simple steps</p>
          
          <div className="relative flex flex-col lg:flex-row items-center justify-between gap-16">
            {/* Progress Line */}
            <div className="hidden lg:block absolute left-1/2 top-[55px] transform -translate-x-1/2 h-[2px] bg-gray-300 w-[75%]"></div>
            
            {/* Step 1 */}
            <div className="flex flex-col items-center md:mt-4 text-center relative z-10 max-w-xs">
              <div className="relative flex items-center justify-center w-20 h-20 border-4 border-gray-300 rounded-full bg-white">
                <FaDoorOpen className="text-[#26a887] text-3xl" />
                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-10 h-10 bg-[#26a887] text-white flex items-center justify-center text-sm font-bold rounded-full">01</div>
              </div>
              <h3 className="text-xl font-semibold mt-4">Sign Up to EximPe</h3>
              <p className="text-gray-600 mt-2">Authenticate with phone number and add the basic details</p>
              <img src={Step1} alt="Sign Up Process" className="w-full max-w-[300px] h-auto mt-4 rounded-lg " />
            </div>
            
            {/* Step 2 */}
            <div className="flex flex-col items-center text-center relative md:mt-4 z-20 max-w-xs">
              <div className="relative flex items-center justify-center w-20 h-20 border-4 border-gray-300 rounded-full bg-white">
                <FaFingerprint className="text-[#26a887] text-3xl" />
                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-10 h-10 bg-[#26a887] text-white flex items-center justify-center text-sm font-bold rounded-full">02</div>
              </div>
              <h3 className="text-xl font-semibold mt-4">Complete your KYC</h3>
              <p className="text-gray-600 mt-2">Upload the relevant KYC documents and company information</p>
              <img src={Step2} alt="KYC Process" className="w-full max-w-[300px] h-auto mt-4 rounded-lg " />
            </div>
            
            {/* Step 3 */}
            <div className="flex flex-col items-center md:mt-2 text-center relative z-10 max-w-xs">
              <div className="relative flex items-center justify-center w-20 h-20 border-4 border-gray-300 rounded-full bg-white">
                <FaTelegramPlane className="text-[#26a887] text-3xl" />
                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-10 h-10 bg-[#26a887] text-white flex items-center justify-center text-sm font-bold rounded-full">03</div>
              </div>
              <h3 className="text-xl font-semibold mt-4">Open Trade Account</h3>
              <p className="text-gray-600 mt-2">Create an order and start payments</p>
              <img src={Step3} alt="Trade Account" className="w-full max-w-[300px] h-auto mt-4 rounded-lg " />
            </div>
          </div>
        </div>
      </div>
    )
}